"use client";

import { useBuilder } from "@/context/BuilderContext";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import { useBuilderOptions } from "@/hooks/useBuilderOptions";

export function StepTexture() {
  const { selections, setOption } = useBuilder();
  const selected = selections.texture;
  const { options } = useBuilderOptions();
  const dbPrices = new Map((options.texture || []).map((o) => [o.value, o.price]));

  const TEXTURES = [
    {
      value: "Straight",
      price: dbPrices.get("Straight") ?? 0,
      label: "Straight",
      description: "Sleek and smooth. The most versatile texture — can be curled or styled for any occasion.",
      pattern: "M0,15 L60,15",
    },
    {
      value: "Wavy",
      price: 0,
      label: "Wavy",
      description: "Natural-looking waves that add volume and movement. Effortless, beach-ready style.",
      pattern: "M0,20 Q15,5 30,20 Q45,35 60,20",
    },
    {
      value: "Curly",
      price: 0,
      label: "Curly",
      description: "Beautiful, bouncy curls with natural-looking definition and volume.",
      pattern: "M0,20 Q5,5 10,20 Q15,35 20,20 Q25,5 30,20 Q35,35 40,20 Q45,5 50,20 Q55,35 60,20",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
      {TEXTURES.map((option) => {
        const isSelected = selected === option.value;
        return (
          <button
            key={option.value}
            onClick={() => setOption("texture", option.value, option.price)}
            className={cn(
              "group relative overflow-hidden rounded-xl border-2 p-4 sm:p-5 text-start transition-all duration-500 ease-out",
              isSelected
                ? "border-brand-gold bg-brand-gold/5 shadow-md shadow-brand-gold/10"
                : "border-brand-dark/8 hover:border-brand-gold-light hover:shadow-sm"
            )}
          >
            {/* SVG wave pattern */}
            <div className="mb-4 flex justify-center">
              <svg viewBox="0 0 60 35" className="h-10 w-full max-w-[120px]" fill="none">
                <path
                  d={option.pattern}
                  stroke={isSelected ? "#c9a96e" : "#999"}
                  strokeWidth={2.5}
                  strokeLinecap="round"
                  className="transition-colors duration-500"
                />
              </svg>
            </div>

            <h3 className={cn(
              "font-display text-base tracking-tight text-center mb-1",
              isSelected ? "text-brand-dark" : "text-brand-dark/80"
            )}>
              {option.label}
            </h3>
            <p className="text-xs text-brand-muted text-center leading-relaxed">
              {option.description}
            </p>

            {isSelected && (
              <div className="absolute top-2.5 end-2.5 flex h-5 w-5 items-center justify-center rounded-full bg-brand-gold text-white animate-scale-in">
                <Check className="h-3 w-3" strokeWidth={3} />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
